import React from "react"
import { graphql } from "gatsby"

import extractNavigation from "../../utils/extract-navigation"

import Page from "../../components/page"
import Article from "../../components/article/article"
import Footer from "../../components/footer"

import "normalize.css"
import "../../assets/scss/site.scss"

export const query = graphql`
  query ArticlePage($key: String!) {
    article: datoCmsArticle(key: { eq: $key }, locale: { eq: "en" }) {
      ...ArticleFields
    }
    footer: datoCmsFooter {
      ...FooterFields
    }
    translations: allLanguagesYaml {
      ...LanguagesData
    }
    navigationData: allNavigationYaml {
      ...NavigationData
    }
    navigationSecondaryData: allNavigationSecondaryYaml {
      ...NavigationSecondaryData
    }
    everyArticleEn: allDatoCmsArticle(
      filter: { hidden: { ne: true }, locale: { eq: "en" } }
      sort: { fields: publishedDate, order: DESC }
      limit: 500
    ) {
      nodes {
        ...ArticleTeaserFields
      }
    }
  }
`

import { ArticlePageQuery } from "../../../graphql-types"

interface ArticlePageProps {
  data: ArticlePageQuery
}

const ArticleRoute: React.FC<ArticlePageProps> = ({ data }) => {
  return (
    <Page
      translations={data.translations}
      navigationData={extractNavigation(data.navigationData)}
      navigationSecondaryData={extractNavigation(data.navigationSecondaryData)}
      seoMetaTags={data.article.seoMetaTags}
      metaDescription={
        data.article.metaTags ? data.article.metaTags.description : ""
      } // Should not be necessary, but seoMetaTags seems to lack this.
    >
      <Article data={data.article} articles={data.everyArticleEn.nodes} />
      <Footer {...data.footer} />
    </Page>
  )
}

export default ArticleRoute
